import { render, staticRenderFns } from "./viewTbDialog.vue?vue&type=template&id=c8637696&"
import script from "./viewTbDialog.vue?vue&type=script&lang=js&"
export * from "./viewTbDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports